import type { ComponentProps, CSSProperties, ReactElement, ReactNode } from 'react';
import { Children, isValidElement, useState } from 'react';
import { Tabs as CosmaTabs } from 'is24-corecss';

export const Tabs = ({
  children,
  className,
  defaultValue,
  listClassName = '',
  'aria-label': label,
}: {
  children: ReactNode;
  className?: ComponentProps<typeof CosmaTabs.Root>['className'];
  defaultValue?: string;
  listClassName?: string;
  'aria-label'?: string;
}) => {
  const tabs = Children.toArray(children).filter(
    (child): child is ReactElement<ComponentProps<typeof Tab>> => isValidElement(child) && child.type === Tab,
  );
  const [selected, setSelected] = useState(defaultValue ?? tabs[0]?.props.tabKey);
  const activeTab = tabs.find((tab) => tab.props.tabKey === selected)?.props.tabKey ?? tabs[0]?.props.tabKey;
  if (!activeTab) {
    return null;
  }
  return (
    <CosmaTabs.Root value={activeTab} onValueChange={setSelected} className={className}>
      <CosmaTabs.List
        aria-label={label}
        className={`grid-justify-center margin-bottom-none padding-top-m palm-padding-top-l padding-bottom-l ${listClassName}`}
      >
        {tabs.map(({ props: { tabKey, title } }) => (
          <CosmaTabs.Tab key={tabKey} value={tabKey}>
            {title}
          </CosmaTabs.Tab>
        ))}
      </CosmaTabs.List>
      {tabs}
    </CosmaTabs.Root>
  );
};

export const Tab = ({
  tabKey,
  className,
  style,
  children,
}: {
  tabKey: string;
  title: ReactNode;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}) => (
  <CosmaTabs.Panel value={tabKey} className={className} style={style}>
    {children}
  </CosmaTabs.Panel>
);
